<template>
  <div>
    <el-popover
      placement="right"
      width="180"
      trigger="click"
      popper-class="popover"
      >
      <el-image class="code_image" :src="img_url" fit="cover"></el-image>
      <div slot="reference" class="handle-button"><i class="el-icon-service" size="large" /></div>
    </el-popover>
  </div>
</template>

<script>

export default {
  data() {
    return {
      img_url: require("@/assets/img/contact_us.png"),
    }
  }
  
}
</script>


<style scoped>
.handle-button {
  width: 48px;
  height: 48px;
  position: absolute;
  left: 0;
  top: 50%;
  text-align: center;
  font-size: 25px;
  border-radius: 8px 8px 8px 8px !important;
  z-index: 1000;
  pointer-events: auto;
  cursor: pointer;
  background-color: #e3f8c4;
  line-height: 48px;
}
.code_image {
  width: 180px;
  height: 100px;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/LeftPanel/index.vue